import { resolveImagePath } from "@/utils/imageMap.ts";

export function ContactHero() {
  const heroImage = resolveImagePath("/images/contact-hero.jpg");

  return (
    <section className="relative h-[500px] flex items-center justify-center">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${heroImage})`,
        }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/40" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 text-center text-white">
        <h1 className="text-5xl font-light tracking-wide">
          CONTACT US
        </h1>
      </div>
    </section>
  );
}